<script lang="ts">
  import { toasts } from '@/stores/toasts';

  const variantClasses = {
    success: 'border-success/30 bg-success-light text-success-dark dark:bg-success/15 dark:text-success',
    error: 'border-error/30 bg-error-light text-error-dark dark:bg-error/15 dark:text-error',
    info: 'border-primary/20 bg-primary-50 text-primary-800 dark:bg-primary/15 dark:text-primary-100',
  } as const;
</script>

<div class="pointer-events-none fixed right-4 top-5 z-[80] flex w-[min(24rem,calc(100vw-2rem))] flex-col gap-2">
  {#each $toasts as toast (toast.id)}
    <div
      class={`pointer-events-auto rounded-2xl border px-4 py-3 shadow-lg backdrop-blur-sm ${variantClasses[toast.variant]}`}
      role="status"
      aria-live="polite"
    >
      <div class="flex items-start justify-between gap-3">
        <p class="text-sm font-medium leading-5">{toast.message}</p>
        <button
          type="button"
          class="shrink-0 text-current/70 transition hover:text-current"
          aria-label="토스트 닫기"
          onclick={() => toasts.dismiss(toast.id)}
        >
          <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  {/each}
</div>
